import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import {
  type ApiError,
  type ApiResponse,
  addActionNameToMutationResult,
  useAxiosInstance,
} from 'shared/hooks/utils';

type ResendReminderVariables = {
  id: string;
  emails: Array<string>;
};

export async function resendReminderFn(
  axiosInstance: Promise<AxiosInstance>,
  { id, emails }: ResendReminderVariables,
): Promise<ApiResponse> {
  const instance = await axiosInstance;

  return instance.post(`/payment_requests/${id}/resend`, { emails });
}

export function useResendReminder() {
  const client = useQueryClient();
  const axiosInstance = useAxiosInstance();

  const mutation = useMutation<ApiResponse, ApiError, ResendReminderVariables>({
    mutationFn: variables => resendReminderFn(axiosInstance, variables),
    onSuccess: () => {
      client.invalidateQueries({
        queryKey: ['reminders'],
      });
    },
  });

  return addActionNameToMutationResult<
    ApiResponse,
    ApiError,
    ResendReminderVariables,
    'resendReminder'
  >('resendReminder', mutation);
}
